import { render, staticRenderFns } from "./StepSpectatorsComponent.vue?vue&type=template&id=14179f06"
import script from "./StepSpectatorsComponent.vue?vue&type=script&lang=js"
export * from "./StepSpectatorsComponent.vue?vue&type=script&lang=js"
import style0 from "./StepSpectatorsComponent.vue?vue&type=style&index=0&id=14179f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports